<template>
  <div>
    <router-link class="qa-box-index" :to="{name: 'fullComment', params: {pathID:comment.path[0].itemRefID, chapterID: comment.chapterId, commentID: comment._id}}">
      <p class="qa-index-head">{{comment.title}}</p>
      <div class="index-txt" v-html="comment.content"></div>
      <p class="top-name">{{comment.name}}</p>
      <p class="top-date">{{createdDate}}</p>
      <div v-if="comment.replies && comment.replies.length" class="comments">תגובות ({{comment.replies.length}})
        <div v-for="reply in comment.replies.slice(0,3)" :key="reply._id">
          <hr style="border:1px solid rgba(43, 53, 64, 0.2)">
          <span>{{reply._createdDate}}</span> | <span>{{reply.name}}</span><br>
          <b>{{reply.title}}</b><br>
          <div v-html="reply.content"></div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "singleComment",
  // data: function () {
  //     return {

  //     }
  // },
  props: {
    comment: Object,
  },
  computed: {
    createdDate() {
      var date = new Date(this.comment._createdDate);
      return `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },
  },
};
</script>

<style scoped>
  .comments{
    font-size: 14px;
    color:grey;
    padding: 10px;
    padding-right: 20px;
  }
</style>